<template>
  <div id="team">
    <div id="team-content">
      <Header
        :page="'team'"
        :title_one="'team'"
        :action_one="event.main_actions ? 'edit' : ''"
      ></Header>

        <div class="row stepper-alert" v-if="showDeadlines">
          <TeamProgressAlert
            :steps-completed="stepsCompleted"
            :total-steps="totalSteps"
            :next-step-label="$t(nextStepLabel)"
          ></TeamProgressAlert>
        </div>

        <div class="row club-stepper" v-if="showDeadlines">
          <ArrowStepper :steps="stepStates" />
        </div>

      <div class="row team-name">
        <span v-if="team.category" class="team-category">
          {{ $t("params.category") + " " + team.category.max_age }}
        </span>
        <span class="team-title">{{ team.name }}</span>
      </div>
      <div v-if="parseInt(team.invited) == 1" class="team-invited">
        <span class="team-category">{{
          $t("params.team") + " " + $t("params.invited")
        }}</span>
      </div>

      <div class="left">
        <span class="title title-team">{{ $t("titles.team_image") }}</span>
        <div
          class="row image-team"
          :class="{ empty: !team.photo }"
          :style="
            team.photo ? { backgroundImage: 'url(' + team.photo + ')' } : {}
          "
        >
          <span
            class="no_image"
            v-if="!team.photo"
            v-html="$t('descriptions.no_image')"
          ></span>
        </div>
        <div class="clear" style="height: 30px"></div>
        <template v-if="user.admin">
          <span class="title">{{ $t("titles.gestor") }}</span>
          <template v-if="Object.keys(gestor).length > 0">
            <div class="row gestor">
              <div class="left">
                <span class="name">{{ gestor.name }}</span>
                <span class="mail">{{ gestor.email }}</span>
              </div>
              <div class="right">
                <button class="mainButton" @click="openDialog()">
                  {{ $t("delete") }}
                </button>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="row actions">
              <button class="mainButton" @click="addGestor()">
                {{ $t("add") }}
              </button>
            </div>
          </template>
        </template>

        <span class="title">{{ $t("titles.tournament_representative") }}</span>
        <div
          class="representative"
          v-if="Object.keys(representative).length > 0"
          @click="openRepresentativeProfile()"
        >
          <div class="item">
            <div class="label">{{ $t("params.name") }}</div>
            <div class="value">{{ representative.name }}</div>
          </div>

          <div class="item">
            <div class="label">{{ $t("params.surname") }}</div>
            <div class="value">{{ representative.surname }}</div>
          </div>

          <div class="item">
            <div class="label">{{ $t("params.phone") }}</div>
            <div class="value">{{ representative.phone }}</div>
          </div>

          <div class="item">
            <div class="label">{{ $t("params.email") }}</div>
            <div class="value">{{ representative.email }}</div>
          </div>
        </div>

        <div class="item" v-else>
          <div class="row actions">
            <div class="descriptions">
              <p>
                <span
                  v-html="$t('descriptions.team_manager_tournament')"
                ></span>
              </p>
            </div>
            <button class="mainButton" @click="redirect()">
              {{ $t("assign") }}
            </button>
          </div>
        </div>
      </div>

      <div class="right">
        <div class="row team-equipment">
          <div class="title">{{ $t("params.local_uniform") }}</div>
          <div class="title">{{ $t("params.visit_uniform") }}</div>
          <!-- Local Uniform -->
          <div
            v-if="team.local_uniform && team.local_uniform.primary_color"
            class="equipment"
          >
            <template v-if="team.event">
              <Equipment
                class="equip"
                :equipment="team.local_uniform"
                :is_preview="true"
                :sport="team.event.sport"
              ></Equipment>
            </template>
          </div>
          <div v-else class="equipment">
            <template v-if="team.event">
              <Equipment
                class="equip empty"
                :equipment="{}"
                :is_preview="true"
                :sport="team.event.sport"
              ></Equipment>
            </template>
            <p
              v-html="
                $t('descriptions.no_assigned_uniform', {
                  s: $t('params.local_uniform'),
                })
              "
            ></p>
          </div>

          <!-- Away Uniform -->
          <div
            v-if="team.away_uniform && team.away_uniform.primary_color"
            class="equipment"
          >
            <template v-if="team.event">
              <Equipment
                class="equip"
                :equipment="team.away_uniform"
                :is_preview="true"
                :sport="team.event.sport"
              ></Equipment>
            </template>
          </div>
          <div v-else class="equipment">
            <template v-if="team.event">
              <Equipment
                class="equip empty"
                :equipment="{}"
                :is_preview="true"
                :sport="team.event.sport"
              ></Equipment>
            </template>
            <p
              v-html="
                $t('descriptions.no_assigned_uniform', {
                  s: $t('params.visit_uniform'),
                })
              "
            ></p>
          </div>
        </div>
      </div>

      <ConfirmPopup
        @close="cancel()"
        @confirm="deleteConfirm()"
        :dialog="dialog"
      ></ConfirmPopup>
    </div>
  </div>
</template>

<script>
/* global moment */
import Equipment from '@/components/ui/Equipment.vue'
import Header from '@/components/layout/Header'
import ConfirmPopup from '@/components/ui/ConfirmPopup.vue'
import ArrowStepper from '@/components/ui/ArrowStepper.vue'
import TeamProgressAlert from '@/components/ui/TeamProgressAlert.vue'

export default {
  name: 'Team',
  components: {
    Equipment,
    Header,
    ConfirmPopup,
    ArrowStepper,
    TeamProgressAlert
  },
  data () {
    return {
      showDeadlines: false,
      club: {},
      team: {},
      players: {},
      staff: {},
      acompanyants: {},
      gestor: {},
      representative: {},
      steps: [],
      dialog: false,
      delete_confirm: false,
      collapseClub: true
    }
  },
  computed: {
    nextStepLabel () {
      const nextStep = this.stepStates.find(s => s.status === 'current')
      return nextStep ? nextStep.label : this.$t('steps.completed_all')
    },
    stepsCompleted () {
      return this.stepStates.filter(s => s.status === 'completed').length
    },
    totalSteps () {
      return this.stepStates.length
    },
    stepStates () {
      const arr = Array.isArray(this.steps) ? this.steps : []
      const firstIncompleteIdx = arr.findIndex(s => !s.completed) // -1 if all done

      return arr.map((s, idx) => {
        const status = s.completed
          ? 'completed'
          : (firstIncompleteIdx === idx ? 'current' : 'pending')

        return {
          id: s.id,
          label: s.step, // i18n key
          completed: s.completed, // boolean
          completed_date: s.date || null,
          status, // 'completed' | 'current' | 'pending'
          deadline: s.limit_date || null
        }
      })
    },
    user () {
      return this.$store.getters['user/getUser']
    },

    event () {
      return this.$store.getters['getCurrentEvent']()
    }
  },
  created () {
    this.load()
  },
  methods: {
    redirect () {
      let event = this.$store.getters.getCurrentEvent()
      let path = 'staff'
      this.$router
        .push({
          name: path,
          params: {
            team_id: this.team.id,
            event: this.$root.formatEventUrl(event.name, event.edition)
          }
        })
        .catch()
      // id == 'undefined' ? this.$router.push({'name' : path}) : this.$router.push({'name' : path, 'params' : {'team_id' : id}});
    },

    pdfGroups () {
      window.open(
        process.env.VUE_APP_APP_URL +
          'documents/MICFootball2022-Grups.pdf/?' +
          moment().unix()
      )
    },

    remove () {
      var self = this
      this.$store
        .dispatch('team/removeGestor', { team_id: this.team.id })
        .then(function () {
          self.$emit('remove', self.team.id)
          self.gestor = {}
        })
    },

    openDialog () {
      // open modal
      this.dialog = true
    },

    deleteConfirm () {
      // close dialog
      this.dialog = false
      // delete gestor
      this.remove()
    },

    cancel () {
      // close dialog
      this.dialog = false
    },

    addGestor () {
      this.$router.push({
        name: 'gestorAdd',
        params: { team_id: this.team.id }
      })
    },

    load () {
      // get user information from store
      var self = this
      if (this.user.admin) {
        this.$store
          .dispatch('club/loadClubEvent', {
            club_id: this.user.club_id,
            event_id: this.user.event_id
          })
          .then(function () {
            var data = self.$store.getters['club/getClub']
            self.club = data
            self.team = data.teams[self.$route.params.id]
              ? data.teams[self.$route.params.id]
              : {}
            self.players = self.team.players
            self.staff = self.team.staff
            self.acompanyants = self.team.acompanyants
            self.gestor = self.team.gestor
              ? self.team.gestor
              : (self.team.gestor = {})
            self.representative = self.team.representative
              ? self.team.representative
              : {}
            self.steps = self.team
              ? self.team.deadlines
              : []
            self.showDeadlines = !!Number(self.team ? self.team.show_deadlines : 0) && self.team.category.max_age != 'INTEGRA'
            // save team to store
            self.$store.commit('team/setTeam', self.team)
          })
      } else {
        this.$store
          .dispatch('team/loadTeam', { team_id: this.$route.params.id })
          .then(function () {
            var data = self.$store.getters['team/getTeam']
            self.club = data.club
            self.team = data.team
            self.players = Object.keys(data.players).length
            self.staff = Object.keys(data.staff).length
            self.acompanyants = Object.keys(data.acompanyants).length
            self.gestor = data.gestor ? data.gestor : (self.gestor = {})
            self.steps = data.deadlines ? data.deadlines : []
            self.showDeadlines = !!Number(data.show_deadlines) && data.team.category.max_age != 'INTEGRA'
            self.representative = data.team.representative
              ? data.team.representative
              : {}
          })
      }
    },

    openRepresentativeProfile () {
      this.$router
        .push({
          name: 'coach',
          params: {
            person_id: this.representative.id
          }
        })
        .catch()
    }
  },
  watch: {
    $route: 'load'
  }
}
</script>

<style lang="scss" scoped>
.mobile {
  display: none;
}

#team {
  background-color: #fff;
  margin: 0;
  padding: 0;
  height: 100%;

  .shield {
    border: 1px solid #ddd;
  }
  .data {
    padding-left: 20px;
  }
}

#team-content {
  display: inline-block;
  margin: 0;
  // padding: 15px;
  width: 100%;
  height: auto;
  // background-color: $secondary-color;
  .row.club-stepper {
    overflow: visible;   /* ✅ don't clip chevrons */
    display: block;      /* let child take full width */
    padding: 8px 0 16px;
    margin-bottom: 8px;
    margin-top: -20px;

    .chevron-progress-stepper { width: 100%; }
  }
  .row.stepper-alert {
    overflow: visible;   /* ✅ don't clip chevrons */
    display: block;      /* let child take full width */
    padding: 8px 0 0px;
    margin-bottom: -8px;

    .chevron-progress-stepper { width: 100%; }
  }
  .row {
    // background-color: #f5f5f5;
    // background-color: $secondary-color;
    border-radius: 3px;
    text-align: center;
    overflow: hidden;
    margin-bottom: 24px;
    height: auto;

    .title {
      display: block;
      width: 100%;
    }

    .label,
    .value {
      display: inline-block;
    }
    .label {
      font-weight: bold;
      width: 100px;
    }

    .list-title {
      @include background(
        $image: img("right-arrow.svg"),
        $size: 12px,
        $position: right 6px center
      );
      height: 40px;
      width: 100%;
      display: block;
      padding: 0 20px;
      font-size: 24px;
      line-height: 40px;
    }
  }

  .actions {
    button {
      width: 50%;
    }
  }

  .title {
    font-size: 16px !important;
    font-weight: bold;
    color: #191919;
    display: block;
    width: 100%;
    margin: 6px;
    font-family: AvantGarde-Bold !important;
    text-transform: uppercase;
    padding: 2px 0;
  }

  .image-team {
    // @include background( $image: img('empty_team.jpg'), $size: contain, $color: transparent, $position: center );
    @include background($size: contain, $color: transparent, $position: center);
    height: 260px;
    margin-bottom: 12px;

    &.empty {
      opacity: 0.5;
      border: 2px dashed #eee;
      margin-left: auto;
      margin-right: auto;
      width: 100%;
    }
  }

  .image-team.empty {
    @include opacity(0.5);
    @include background(
      $image: img("empty-team.svg"),
      $position: 20px right,
      $size: 150px
    );
    .no_image {
      line-height: 450px;
    }
  }

  .team-name {
    background: none;
    width: 100%;
    overflow: hidden;
    text-align: left;

    .team-title {
      color: #999;
    }

    .team-category,
    .team-title {
      @include text-ellipsis();
      display: inline-block;
      font-size: 18px;
      padding: 0 5px;
    }

    .team-category {
      margin-right: 0px;
      text-transform: uppercase;
      font-weight: bold;
      // font-size: 22px;
      font-family: AvantGarde-Bold;
    }
  }

  .team-invited {
    line-height: 30px;
    &::before {
      content: " ";
      width: 30px;
      height: 30px;
      @include background(
        $image: img("star.svg"),
        $size: 24px,
        $position: left center
      );
      position: absolute;
    }

    span {
      padding-left: 30px;
      text-transform: uppercase;
      font-weight: bold;
      font-family: AvantGarde-Bold;
    }
  }

  .resume {
    width: 100%;
    text-align: center;

    .item {
      @include background(
        $image: img("right-arrow.svg"),
        $size: 16px,
        $position: right 6px center
      );
      @include border-radius(3px);
      @include display-inline-flex();
      @include align-items();
      height: 50px;
      width: 60%;
      background-color: $secondary-color;
      margin: 10px 10px 0 10px;
      padding: 2px 9px 2px 0px;
      cursor: pointer;
      transition-duration: 0.2s;

      .value,
      .label {
        color: $main-color;
      }
      .value {
        width: 75px;
        height: 100%;
        font-size: 24px;
        font-weight: bold;
        text-align: center;

        .count,
        .total {
          display: inline-block;
          color: $main-color;
          line-height: 45px;
        }
        .count {
          font-size: 30px;
          margin-right: 2px;
        }
        .total {
          font-size: 16px;
          font-weight: bold;
        }
      }
      .label {
        @include text-ellipsis();
        width: calc(100% - 75px);
        font-size: 20px;
        font-weight: bold;
        padding: 2px;
      }

      // &:hover {
      //   // background-color: $bg-color;
      // }
      &:last-of-type {
        margin-bottom: 10px;
      }

      &.alert {
        @include background(
          $image: img("right-arrow.svg"),
          $size: 16px,
          $position: right 6px center
        );

        // .label {
        // }
        .value {
          @include background(
            $image: img("empty_estimated_warning.svg"),
            $size: 30px,
            $position: center
          );
        }
      }
    }
  }

  .representative {
    background-color: #f5f5f5;
    border-radius: 3px;
    text-align: center;
    overflow: hidden;
    margin-bottom: 24px;
    padding: 6px 12px;
    height: auto;
    transition: background-color 0.5s ease;
    cursor: pointer;

    .item {
      display: inline-block;
      margin-bottom: 6px;
      width: 50%;

      &.mid {
        width: 50%;
      }

      .alergy {
        color: inherit;
        font-size: inherit;
        font-weight: inherit;

        &:after {
          content: ", ";
        }
        &:last-of-type:after {
          content: "";
        }
      }
    }

    .label,
    .value {
      display: inline-block;
      font-size: 15px;
    }
    .label {
      width: 100px;
      text-align: right;
      margin-right: 12px;
      text-transform: uppercase;
      font-size: 12px;

      &:after {
        content: ":";
      }
    }
    .value {
      font-weight: bold;
    }

    &:hover {
      background-color: #e9e9e9;
    }
  }

  .club-info {
    @include display-flex();
    @include align-items(center);
    background-color: #f5f5f5;
    padding: 12px;

    .shield,
    .info {
      float: left;
    }
    .shield {
      @include background($size: cover);
      width: 100px;
      height: 100px;
      border: none;
      border-radius: 3px;
      margin: 0 auto;
    }
    .info {
      width: calc(100% - 100px);
      padding-left: 12px;
    }

    .label {
      @include text-ellipsis();
      text-align: right;
      margin-right: 6px;
    }
    .value {
      @include text-ellipsis();
    }
  }

  .gestor {
    @include background(
      $image: img("user_filled.svg"),
      $size: 20px,
      $position: left 12px center,
      $color: #f5f5f5
    );
    @include text-ellipsis();
    line-height: 40px;
    min-height: 40px;
    display: block;
    font-size: 18px;
    font-weight: bold;
    // color: $main-color;
    text-align: left;
    padding: 6px 6px 6px 40px;

    &.empty {
      font-weight: initial;
      // background-image: img('user_empty.svg');
    }

    .left {
      .name,
      .mail {
        line-height: inherit;
        font-size: inherit;
        font-weight: inherit;
      }
      .mail {
        font-weight: normal;
        margin-left: 6px;
      }
    }

    .right {
      height: 100%;
      padding: 5px;
    }
  }

  .team-equipment {
    text-align: left;

    .title {
      width: 46%;
      display: inline-block;
      margin: 0 2% 6px 2%;
    }

    .equipment {
      // @include display-inline-flex();
      // @include justify-content(center);
      width: 46%;
      margin: 0 2%;
      display: inline-block;
      vertical-align: top;
      p {
        text-align: center;
      }
    }

    .equip {
      padding: 12px;
      border-radius: 5px;
      border: 2px solid #eee;
      // max-width: 150px !important;
      width: 100%;
      // display: inline-block;
      display: block;
    }

    .equip.empty {
      opacity: 0.1;
    }
  }

  .left,
  .right {
    width: 50%;
    display: inline-block;
    padding: 12px;
  }

  // .left {
  // }

  // .right {
  // }
}

.mainButton {
  // width: 100%;
  // padding: 5px;
  width: 150px !important;
  padding: 0;
  margin: 0;
  // width: 100%;
  height: 100%;
  min-width: 40px;
  outline: none;
  cursor: pointer;
  font-size: 8pt;
  font-family: Speedee-Bold;
  // margin-top: 5px;
  border-radius: 3px;
  border: 1px solid #fc8926;
  text-transform: uppercase;
  background-color: transparent;
  color: #c55c00;
  height: 40px;
  padding: 0;
  font-family: Roboto-Bold;
  font-size: 14px;
  line-height: 14px;
  transition: background-color 0.5s ease;
  float: left;

  &:hover {
    background-color: #fc8a2623 !important;
  }
}
/*
    .item {
      .label {
        font-size: 18px;
        display: inline-block;
        width: 150px;
        margin-bottom: 10px;
      }

      .value {
        font-size: 18px;
        display: inline-block;
        font-weight: bold;
        margin-bottom: 10px;
      }
    }
    */

@include media("<=desktop") {
  #team-content {
    .image-team {
      height: 200px;
    }

    .resume .item {
      width: 90%;
    }

    .left,
    .right {
      width: 100%;
      display: block;
      padding: 0;
    }

    .title-club {
      @include background(
        $image: img("up_dark.svg"),
        $size: 10px,
        $position: right 16px center
      );
      padding-right: 30px;
      display: block;
      &.closed {
        background-image: img("down.svg");
      }
    }
    .club-info {
      height: auto;
      overflow: hidden;

      &.closed {
        padding: 0;
        height: 0;
        border-top: 2px solid #eee;
      }

      .shield {
        float: none;
      }
      .info {
        width: 100%;
        float: none;
      }
    }

    .gestor {
      background: none;

      .left {
        @include background(
          $image: img("user_filled.svg"),
          $size: 20px,
          $position: left 12px center,
          $color: #f5f5f5
        );
      }

      .left,
      .right {
        display: block;
        width: 100%;
        text-align: center;
      }

      .right {
        button {
          width: 75%;
        }
      }
    }
  }
}

@include media("<desktop") {
  .no_image {
    line-height: 350px !important;
  }

  .representative {
    .item {
      width: 100% !important;
    }
  }
}

@include media(">phone", "<tablet") {
  #team-content {
    .mobile {
      display: block;
    }

    .title-team {
      display: none;
    }

    .club-info {
      @include flex-wrap(wrap);
      @include align-items();

      .shield {
        width: 150px;
        height: 150px;
        margin-bottom: 12px;
      }
    }
  }
}
</style>
